import { ref, onMounted } from "vue";
import { templateRef, useMouseInElement, usePageLeave } from "@vueuse/core";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";


export default {
  __name: 'index',
  props: {
  title: {
    type: String,
    required: false,
  },
  items: {
    type: Array,
    required: true,
  },
  mediaSizes: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props;



const { reveal } = useScrollTriggerAnimation();
const tpl_root = templateRef("tpl_root");
const tpl_title = templateRef("tpl_title");
const tpl_carousel = templateRef("tpl_carousel");
const tpl_swiperEl = templateRef("tpl_swiperEl");
const tpl_next = templateRef("tpl_next");
const tpl_prev = templateRef("tpl_prev");
const tpl_nexPrevArea = templateRef("tpl_nexPrevArea");
const { elementX, elementY, isOutside } = useMouseInElement(tpl_nexPrevArea);
const cursorNextPrevIcon = ref();
const cursorNextPrevIconScaleUp = ref(false);
const isOutsidePage = usePageLeave();
const swiper = ref(null);

onMounted(() => {
  requestAnimationFrame(() => {
    const swiperEl = tpl_swiperEl.value;

    // Configure Swiper Element parameters
    const swiperParams = {
      slidesPerView: "auto",
      speed: 650,
      grabCursor: true,
      threshold: 10,
      spaceBetween: 24,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24,
      roundLengths: true,
      loop: true,
      navigation: {
        nextEl: tpl_next.value,
        prevEl: tpl_prev.value,
      },
      freeMode: {
        enabled: true,
      },
      breakpoints: {
        600: {
          spaceBetween: 16,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
        1024: {
          spaceBetween: 24,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
        },
        1280: {
          freeMode: false,
          spaceBetween: 32,
          slidesOffsetBefore: 56,
          slidesOffsetAfter: 56,
        },
        1536: {
          freeMode: false,
          spaceBetween: 40,
          slidesOffsetBefore: 72,
          slidesOffsetAfter: 72,
        },
        1800: {
          freeMode: false,
          spaceBetween: 56,
          slidesOffsetBefore: 96,
          slidesOffsetAfter: 96,
        },
      },
    };

    // Assign parameters to the element
    Object.assign(swiperEl, swiperParams);

    // Initialize Swiper Element
    swiperEl.initialize();

    // Store swiper instance for potential future use
    swiper.value = swiperEl.swiper;

    if (props.title) {
      reveal(tpl_title.value, tpl_root.value, "right", { fade: true });
    }

    gsap.from(tpl_carousel.value, {
      scrollTrigger: {
        trigger: tpl_root.value,
        start: "top bottom",
        toggleActions: "restart none none reset",
      },
      duration: 1,
      ease: "circ.out",
      yPercent: 40,
      force3D: "auto",
    });

    reveal(swiperEl, tpl_carousel.value, "bottom", {
      intensity: "strong",
      fade: true,
    });
  });
});

return { __sfc: true,props, reveal, tpl_root, tpl_title, tpl_carousel, tpl_swiperEl, tpl_next, tpl_prev, tpl_nexPrevArea, elementX, elementY, isOutside, cursorNextPrevIcon, cursorNextPrevIconScaleUp, isOutsidePage, swiper }
}

}